import React from "react";
import styled from "styled-components";

import { gradeLevelMeta, subjectMeta } from "@examspark/common-meta";
import { Course } from "@examspark/types";

import BankBadge from "../common/BankBadge";

interface Props {
  item: {
    subject?: Array<string | null> | null;
    grade?: Array<string | null> | null;
    updatedAt?: string | Date | null;
    course?: Partial<Course>;
    bankId?: string | null;
  };
  showBank?: boolean;
}

const simpleDateFormat = new Intl.DateTimeFormat("en-US", {
  year: "numeric",
  month: "short",
  day: "numeric",
});

export const ResultFooter = styled.footer`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1.5rem;
  font-size: 1.1rem;
  color: #888;
`;

const ItemMetadata = ({ item, showBank }: Props) => {
  return (
    <ResultFooter>
      {!!item.course && <div>{item.course?.name}</div>}
      {!!subjectMeta[item.subject?.[0] as keyof typeof subjectMeta] && (
        <div>
          {subjectMeta[item.subject?.[0] as keyof typeof subjectMeta]?.label}
        </div>
      )}
      {!!gradeLevelMeta[item.grade?.[0] as keyof typeof gradeLevelMeta] && (
        <div>
          {
            gradeLevelMeta[item.grade?.[0] as keyof typeof gradeLevelMeta]
              ?.label
          }
        </div>
      )}
      {item.bankId && showBank && <BankBadge bankId={item.bankId} plain />}
      {!!item.updatedAt && (
        <div>
          Updated: {simpleDateFormat.format(new Date(item.updatedAt as string))}
        </div>
      )}
    </ResultFooter>
  );
};

export default ItemMetadata;
